import { render, staticRenderFns } from "./RidersFilter.vue?vue&type=template&id=71dfb008&lang=pug&"
import script from "./RidersFilter.vue?vue&type=script&lang=js&"
export * from "./RidersFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports